/** Case-insensitive flag read. Reward$ is shown when the flag is missing. */
export function flagOn(
  source: any,
  name: string,
  presentByDefault = false,
): boolean {
  if (!source || typeof source !== "object") return presentByDefault;
  const want = name.toLowerCase();
  const key = Object.keys(source).find((k) => k.toLowerCase() === want);
  if (!key || source[key] === undefined || source[key] === null) {
    return presentByDefault;
  }
  const value = source[key];
  if (typeof value === "string") return value.toLowerCase() === "true";
  return !!value;
}

function hasFlag(source: any, name: string) {
  if (!source || typeof source !== "object") return false;
  const want = name.toLowerCase();
  return Object.keys(source).some((key) => key.toLowerCase() === want);
}

/** Shown unless this site's Reward$ flag is explicitly off. */
export function rewardsProductOn(source: any): boolean {
  const nested =
    source?.data && typeof source.data === "object" ? source.data : null;
  const body = nested ? { ...source, ...nested } : source;
  const applicationFlag = hasFlag(body, "isEnableRewards");
  const affiliateFlag = hasFlag(body, "isRewards");
  if (!applicationFlag && !affiliateFlag) return true;
  if (applicationFlag && !flagOn(body, "isEnableRewards", true)) return false;
  if (affiliateFlag && !flagOn(body, "isRewards", true)) return false;
  return true;
}
